export const load = () => ({
	h1: 'Snug Fit Guarantee',
	title: 'How We Guarantee Your Inserts Will Fit',
	description:
		'Follow thest steps to ensure your order qualifies for our Snug Fit Guarantee.',
	showTitle: false,
});
